<div class="cm-fundo" *ngIf="aberto" (click)="fechar.emit()"></div>

<aside class="cm" [class.cm-aberto]="aberto" [class.cm-detalhe]="modo !== 'lista'" [attr.aria-hidden]="!aberto" [attr.inert]="aberto ? null : ''"
       role="dialog" aria-label="Mensagens com os médicos">

  <!-- Coluna da esquerda: conversas -->
  <section class="cm-esq">
    <div class="cm-esq-topo">
      <h2 class="cm-titulo">Mensagens</h2>
      <button type="button" class="cm-icone cm-fechar-esq" (click)="fechar.emit()" aria-label="Fechar mensagens">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="cm-busca">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>
      <input [(ngModel)]="busca" (ngModelChange)="filtrar()" placeholder="Buscar médico" aria-label="Buscar conversa" autocomplete="off" />
    </div>

    <div class="cm-abas" role="tablist">
      <button *ngFor="let a of abas" type="button" role="tab" class="cm-aba" [class.cm-aba-ativa]="aba === a.id"
              [attr.aria-selected]="aba === a.id" (click)="escolherAba(a.id)">{{ a.rotulo }}</button>
    </div>

    <div class="cm-conversas">
      <p *ngIf="carregando && !conversas.length" class="cm-vazio">Carregando...</p>
      <p *ngIf="erroLista" class="cm-erro" role="alert">{{ erroLista }}</p>
      <p *ngIf="!carregando && !erroLista && !visiveis.length" class="cm-vazio">Nenhuma conversa.</p>
      <button *ngFor="let c of visiveis; trackBy: porOutro" type="button" class="cm-conversa"
              [class.cm-conversa-sel]="modo === 'conversa' && porOutro(0, c) === aberta" [class.cm-conversa-nova]="c.naoLidas > 0"
              (click)="abrirConversa(c.outro)">
        <span class="cm-avatar" aria-hidden="true">{{ iniciais(c.outro) }}</span>
        <span class="cm-conversa-corpo">
          <span class="cm-linha">
            <span class="cm-conversa-nome">{{ c.outro }}</span>
            <span class="cm-conversa-hora">{{ quando(c.ultima) }}</span>
          </span>
          <span class="cm-linha">
            <span class="cm-conversa-previa">{{ ehMinha(c.ultima) ? 'Você: ' : '' }}{{ previa(c) }}</span>
            <svg *ngIf="ehFavorito(c.outro)" class="cm-estrela" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" role="img" aria-label="Favorita">
              <path d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
            </svg>
            <span *ngIf="c.naoLidas" class="cm-contagem" [attr.aria-label]="c.naoLidas + ' não lidas'">{{ c.naoLidas }}</span>
          </span>
        </span>
      </button>
    </div>

    <div class="cm-rodape">
      <button type="button" class="cm-nova" (click)="novaMensagem()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Z" />
        </svg>
        <span>Nova mensagem</span>
      </button>
    </div>
  </section>

  <!-- Coluna da direita: conversa, nova mensagem ou vazio -->
  <section class="cm-dir">
    <div class="cm-dir-topo">
      <button *ngIf="modo !== 'lista'" type="button" class="cm-icone cm-voltar" (click)="voltar()" aria-label="Voltar para as conversas">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
        </svg>
      </button>
      <ng-container *ngIf="modo === 'conversa'">
        <span class="cm-avatar" aria-hidden="true">{{ iniciais(nomeAberta) }}</span>
        <div class="cm-dir-nome">
          <h3 class="cm-dir-titulo">{{ nomeAberta }}</h3>
          <p *ngIf="especialidade(nomeAberta)" class="cm-dir-sub">{{ especialidade(nomeAberta) }}</p>
        </div>
        <button type="button" class="cm-icone" [class.cm-icone-ativo]="ehFavorito(nomeAberta)" (click)="alternarFavorito()"
                [attr.aria-label]="ehFavorito(nomeAberta) ? 'Tirar dos favoritos' : 'Favoritar conversa'" [attr.aria-pressed]="ehFavorito(nomeAberta)">
          <svg xmlns="http://www.w3.org/2000/svg" [attr.fill]="ehFavorito(nomeAberta) ? 'currentColor' : 'none'" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
          </svg>
        </button>
        <div class="cm-menu-ancora">
          <button type="button" class="cm-icone" (click)="menuAberto = !menuAberto" aria-label="Mais opções" aria-haspopup="menu" [attr.aria-expanded]="menuAberto">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="5" cy="12" r="1.6" /><circle cx="12" cy="12" r="1.6" /><circle cx="19" cy="12" r="1.6" />
            </svg>
          </button>
          <div *ngIf="menuAberto" class="cm-menu" role="menu">
            <button type="button" role="menuitem" (click)="alternarArquivada()">
              {{ ehArquivada(nomeAberta) ? 'Desarquivar conversa' : 'Arquivar conversa' }}
            </button>
          </div>
        </div>
      </ng-container>
      <h3 *ngIf="modo === 'nova'" class="cm-dir-titulo cm-dir-nome">Nova mensagem</h3>
      <span *ngIf="modo === 'lista'" class="cm-dir-nome"></span>
      <button type="button" class="cm-icone" (click)="fechar.emit()" aria-label="Fechar mensagens">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div *ngIf="modo === 'lista'" class="cm-nada">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.4" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" />
      </svg>
      <p>Escolha uma conversa ou clique em Nova mensagem.</p>
    </div>

    <!-- Nova mensagem: escolha do médico -->
    <div *ngIf="modo === 'nova'" class="cm-seletor">
      <div class="cm-busca cm-busca-medico">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
        <input [(ngModel)]="buscaMedico" placeholder="Para: nome ou especialidade" aria-label="Buscar médico" autocomplete="off" />
      </div>
      <p *ngIf="carregandoMedicos" class="cm-vazio">Carregando médicos...</p>
      <p *ngIf="erroMedicos" class="cm-erro cm-erro-seletor" role="alert">{{ erroMedicos }}</p>
      <div *ngIf="medicos" class="cm-medicos">
        <p *ngIf="!medicosVisiveis.length" class="cm-vazio">Nenhum médico encontrado.</p>
        <button *ngFor="let m of medicosVisiveis; trackBy: porMedico" type="button" class="cm-medico" (click)="escolherMedico(m)">
          <span class="cm-avatar" aria-hidden="true">{{ iniciais(m.nmMedico) }}</span>
          <span class="cm-conversa-corpo">
            <span class="cm-conversa-nome">{{ m.nmMedico }}</span>
            <span *ngIf="m.dsEspecialidade" class="cm-conversa-previa">{{ m.dsEspecialidade }}</span>
          </span>
        </button>
      </div>
    </div>

    <!-- Mensagens da conversa -->
    <div *ngIf="modo === 'conversa'" class="cm-mensagens">
      <p *ngIf="!mensagens.length" class="cm-vazio">Nenhuma mensagem ainda. Escreva a primeira abaixo.</p>
      <ng-container *ngFor="let r of mensagens; let i = index; trackBy: porNr">
        <p *ngIf="i === 0 || data(r) !== data(mensagens[i - 1])" class="cm-data">{{ data(r) }}</p>
        <div class="cm-msg" [class.cm-msg-minha]="ehMinha(r)">
          <div class="cm-balao">
            <p *ngIf="r.dsMensagem" class="cm-texto">{{ r.dsMensagem }}</p>
            <ng-container *ngIf="temAnexo(r)">
              <ng-container *ngIf="ehImagem(r); else arquivo">
                <img *ngIf="imagemVisivel(r)" class="cm-imagem" [src]="srcAnexo(r)" [alt]="r.dsArquivoNome || 'Imagem anexada'" />
                <button type="button" class="cm-anexo" [disabled]="baixandoAnexo(r)" (click)="alternarImagem(r)">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Z" />
                  </svg>
                  <span>{{ imagemVisivel(r) ? 'Ocultar imagem' : 'Ver imagem' }}</span>
                </button>
              </ng-container>
              <ng-template #arquivo>
                <button type="button" class="cm-anexo" [disabled]="baixandoAnexo(r)" (click)="baixarArquivo(r)" [attr.aria-label]="'Baixar ' + (r.dsArquivoNome || 'arquivo')">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                  </svg>
                  <span>{{ r.dsArquivoNome || 'Arquivo' }}</span>
                </button>
              </ng-template>
            </ng-container>
          </div>
          <div class="cm-msg-rodape">
            <span>{{ hora(r) }}<ng-container *ngIf="ehMinha(r) && r.ieLido === 'S'"> · Lida</ng-container></span>
            <button *ngIf="ehMinha(r)" type="button" class="cm-excluir" [disabled]="excluindo(r)" (click)="excluir(r)" aria-label="Excluir mensagem">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
              </svg>
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Composição -->
    <div *ngIf="modo === 'conversa'" class="cm-compor">
      <div *ngIf="anexoPendente" class="cm-pendente">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
        </svg>
        <span class="cm-pendente-nome">{{ anexoPendente.nome }}</span>
        <button type="button" class="cm-icone" (click)="removerAnexo()" aria-label="Remover anexo">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <p *ngIf="passouLimite" class="cm-erro" role="alert">A mensagem passou de 2000 caracteres.</p>
      <p *ngIf="erro" class="cm-erro" role="alert">{{ erro }}</p>
      <div class="cm-caixa">
        <label class="cm-icone cm-anexar" title="Anexar arquivo">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
          </svg>
          <input type="file" class="sr-only" aria-label="Anexar arquivo" (change)="escolherArquivo($event)"
                 accept="image/png,image/jpeg,image/gif,image/webp,.pdf,.doc,.docx,.xls,.xlsx,.txt,.zip,.rar,.csv" />
        </label>
        <textarea #caixa [(ngModel)]="texto" (input)="ajustarAltura(caixa)" (keydown)="teclaTexto($event)" (paste)="colar($event)" rows="1"
                  placeholder="Mensagem" title="Ctrl+Enter envia" aria-label="Mensagem"></textarea>
        <span *ngIf="mostrarContador" class="cm-contador" [class.cm-contador-erro]="passouLimite">{{ tamanho }}/{{ limiteTexto }}</span>
        <button type="button" class="cm-enviar" [disabled]="enviando || passouLimite" (click)="enviar()"
                [attr.aria-label]="enviando ? 'Enviando' : 'Enviar'" title="Enviar (Ctrl+Enter)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18" />
          </svg>
        </button>
      </div>
    </div>
  </section>
</aside>
